export const TOLD_SDK_LOADED_EVENT = 'told:sdk-loaded';
